module.exports = __webpack_public_path__ + "static/media/candle-for-pet.bf7211dc.png";